import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Switch, Route } from 'react-router-dom';
import { get, isEmpty } from 'lodash';

import {
  fetchOutletDetailsAction,
  clearApiErrorResponseAction,
  fetchAppStartupInfoAction,
} from '../../actions/common';
import { extractWhitelabelSubdomain } from '../../utils/helpers';
import { getErrorTitle, getErrorDescription } from '../../selectors';
import { outletDetailsSize, restaurantDataDepthParams } from '../../constants/globals';
import { constants } from '../../constants/configuration';
import asyncRoute from '../../helpers/hoc/asyncRoute';
import routes from '../../routes';

const FeedbackForm = asyncRoute(() => import('./FeedbackForm'));
const FeedbackSuccess = asyncRoute(() => import('./FeedbackSuccess'));
const ExceptionComponent = asyncRoute(() => import('../../components/ExceptionComponent'));
const feedbackConfig = constants.feedback;
const Feedback = ({ match, greetingSplashScreen, errorResponse, actions }) => {
  const [initialAPIInteractionDone, setInitialAPIInteractionDone] = useState(false); // Whether the API calls on mount have completed (irrespective of SUCCESS or ERROR response)
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorContent, setErrorContent] = useState({});

  useEffect(() => {
    window.scrollTo({ top: 0 });
    const subDomain = extractWhitelabelSubdomain();
    if (subDomain) {
      const appStartupReqBody = {
        subdomain: subDomain,
        includeModules: ['engage', 'brand'],
      };
      const { config } = restaurantDataDepthParams;
      const url = `/brands/${subDomain}/outletDetails?size=${outletDetailsSize}&depth=${[config]}`;

      Promise.allSettled([
        actions.fetchAppStartupInfo({ appStartupReqBody }),
        actions.fetchOutletDetails({ url }),
      ]).then(() => {
        // As the API call on mount has completed, mark the initialAPIInteractionDone as true
        setInitialAPIInteractionDone(true);
      });
    }
  }, []);

  useEffect(() => {
    if (!isEmpty(errorResponse)) {
      const { code, message } = errorResponse;
      const draftErrorContent = {
        title: getErrorTitle({ source: feedbackConfig, code }),
        description: getErrorDescription({ source: feedbackConfig, code, message }),
      };
      setShowErrorPopup(true);
      setErrorContent(draftErrorContent);
    }
  }, [errorResponse]);

  const onCloseExceptionComponent = () => {
    actions.clearApiErrorResponseAction().then(() => {
      setShowErrorPopup(false);
      setErrorContent({});
    });
  };

  return (
    <>
      {/* render greeting splash screen here */}
      {greetingSplashScreen && greetingSplashScreen}
      {initialAPIInteractionDone && (
        <Switch>
          <Route
            path={`${match.path}/:restaurantCode/${routes.feedback.success}`}
            component={FeedbackSuccess}
          />
          <Route path={`${match.path}/:restaurantCode`} component={FeedbackForm} />
          <Route path={`${match.path}`} component={FeedbackForm} />
        </Switch>
      )}
      <ExceptionComponent
        pageType="HalfSize"
        openSegmentPopup={showErrorPopup}
        dismissSegmentPopup={onCloseExceptionComponent}
        title={get(errorContent, 'title')}
        description={get(errorContent, 'description')}
      />
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      fetchOutletDetails: fetchOutletDetailsAction,
      clearApiErrorResponseAction: clearApiErrorResponseAction,
      fetchAppStartupInfo: fetchAppStartupInfoAction,
    },
    dispatch,
  ),
});

const mapStateToProps = (state) => ({
  errorResponse: get(state, 'common.errorResponse', {}),
  appStartupInfo: get(state, 'common.appStartupInfo', {}),
  guestFeedback: get(state, 'app.guestFeedback', {}),
});

export default connect(mapStateToProps, mapDispatchToProps)(Feedback);
